import { Person } from './person';
import { Contact } from './contact';

export class PersonContact extends Contact {
  person: Person = null;

  constructor() {
    super();
  }
}
